<template>
  <div>
    <AppLogInModal
      key="loginIn"
      v-show="login"
      @ready="ready = true"
      @register="showRegister"
      @reset="showReset"
    />
    <AppRegisterModal
      key="register"
      v-show="register"
      @ready="ready = true"
      @login="showLogin"
    />
    <AppResetModal key="reset" v-show="reset" @ready="ready = true" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import AppLogInModal from '~/components/modals/AppLogInModal'
import AppRegisterModal from '~/components/modals/AppRegisterModal'
import AppResetModal from '~/components/modals/AppResetModal'

export default {
  data() {
    return {
      login: true,
      register: false,
      reset: false,
      ready: false,
      success: false
    }
  },
  components: {
    AppLogInModal,
    AppRegisterModal,
    AppResetModal
  },
  computed: {
    ...mapGetters({
      loggedIn: 'auth/loggedIn'
    })
  },
  methods: {
    showRegister(evt) {
      this.register = evt
      this.login = false
    },
    showReset(evt) {
      this.reset = evt
      this.register = false
      this.login = false
    },
    showLogin(evt) {
      this.login = evt
      this.reset = false
      this.register = false
    }
  }
}
</script>

<style lang="scss">
.modal-enter-active,
.modal-leave-active {
  @include ease-out;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// components/modals/AppModalWrapper.vue